export function isMac(userAgent: string): boolean {
  return /Macintosh/.test(userAgent);
}
